export const gamesArray = [
    {
      name: "Hangman",
      image: "./gamex1.png", // Replace with actual image URL
      description: "A classic word-guessing game where players try to guess a hidden word by suggesting letters."
    },
    {
      name: "Typeracer",
      image: "./gamex3.png", // Replace with actual image URL
      description: "A typing competition game where players race against each other to type a given text accurately and quickly."
    },
    {
      name: "Match Game",
      image: "./gamex2.png", // Replace with actual image URL
      description: "A memory game where players flip cards to find matching pairs within a set of facedown cards."
    },
    {
      name: "Rock-Paper-Scissors",
      image: "./gamex4.png", // Replace with actual image URL
      description: "A hand game usually played between two people, where each player simultaneously forms one of three shapes with their hand."
    }
  ];